// Pathfinder Unchained Variant Multiclassing — Fighter archetype benefit tiers.
const fighterArchetype = [
	{
		level: 3,
		name: 'Bravery',
		description: 'You gain the bravery class feature, as a fighter of your character level – 1.',
	},
	{
		level: 7,
		name: 'Armor Training 1',
		description: 'You gain armor training 1.',
	},
	{
		level: 11,
		name: 'Weapon Training 1',
		description: 'You gain weapon training 1.',
	},
	{
		level: 15,
		name: 'Armor Training 2',
		description: 'You gain armor training 2.',
	},
	{
		level: 19,
		name: 'Weapon Training 2',
		description: 'You gain weapon training 2.',
	},
];

export default fighterArchetype;
